/**
 * @file getFirstQuestion.ts
 * Exports a method that fetches the first object in the array of questions.
 */
import { last, pipe, prop } from 'ramda';
import { getQuestions } from '.';
import type { AppState, QuestionData } from '../types';

/**
 * Helper method that returns the last object in the array of questions.
 *
 * @param {AppState} appState
 *   The state object shared across the application.
 *
 * @returns {QuestionData}
 *   Question data object, or undefined.
 */
export default (appState: AppState): QuestionData =>
  pipe(
    // Retrieve the list of question from appState.
    getQuestions,
    // Grab the last question in the array of questions.
    last,
    // Return the question id of the last question.
    prop('id'),
  )(appState);
